export default ['$rootScope', contentCommentDirective]

// todo: daniel: make eventHandler modules for composable components
export function contentCommentDirective() {
  return {
    restrict: 'A',
    link: function(scope, elem, attr, ctrl) {
      elem.on('keydown', (e) => {
        if (e.which === 13) {
          e.preventDefault()
          return false
        }
      })
    },
  }
}
